import { dateTimeFromServer } from '../utils/format'
import { JSON } from '../utils/types'
import { PaymentMethod } from './PaymentMethod'

export default class Mach extends PaymentMethod {
  readonly appLink: string
  readonly qrCodeBase64Image: string
  readonly instructions: string[]
  readonly formattedExpirationDate: string

  constructor(data: JSON) {
    super(data)
    this.appLink = data.app_link
    this.qrCodeBase64Image = data.qr_code_base64_image
    this.instructions = data.instructions ?? []
    this.formattedExpirationDate = dateTimeFromServer(this.expirationDate, true)!
  }
}
